import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLayoutComponent } from './app-layout.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../MaterialAngular/material.module';

@NgModule({
  declarations: [AppLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule
  ],
  exports: [AppLayoutComponent] 
})
export class AppLayoutModule { }
